import { Component, ViewChild, OnInit, ElementRef } from '@angular/core';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { SelectedEventArgs } from '@syncfusion/ej2-angular-inputs';
import { EmitType } from '@syncfusion/ej2-base';
import { HttpService } from '../../services/http.service';

@Component({
    selector: 'import-file-dialog',
    templateUrl: './import-file-dialog.html',
})
export class ImportFileDialogComponent {
    @ViewChild('dlg') dlg: DialogComponent;
    visible: boolean = false;
    isChanged: boolean = false;
    params: any = null;
    callback: any = null;
    path: any = null;
    //path: any = {
    //    saveUrl: `${this.http.getUrl()}api/DetailProduct/ImportZPV`,
    //    removeUrl: ''
    //};

    constructor(private http: HttpService) {
    }

    show(url: string, params: any, callback) {
        this.path = { saveUrl: `${this.http.getUrl()}${url}` };
        this.params = params;
        this.callback = callback;
        this.dlg.show();

        console.log(this.path.saveUrl);
    }

    public onFileUpload: EmitType<SelectedEventArgs> = (args: any) => {
        console.log('start import');
        console.log(this.params);

        args.customFormData = this.params;
    };

    public onUploadSuccess(args: any): void {
        if (args.operation === 'upload') {
            this.isChanged = true;
            console.log('File uploaded successfully');
        }
    }

    onClose(evt: any) {
        if (this.callback != null)
            this.callback();
    }
}
